export enum SeatingType {
  GENERAL = 'general',
  RANDOM = 'random',
  SELECTED = 'selected',
}

export const SeatingTypeLabels = {
  [SeatingType.GENERAL]: 'Geral',
  [SeatingType.RANDOM]: 'Aleatório',
  [SeatingType.SELECTED]: 'Marcado',
}
